import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Notification } from '@app/models/notifications/notifications.model';
@Component({
    selector: 'app-device-moved',
    templateUrl: './device-moved.component.html',
    styleUrls: ['./device-moved.component.scss'],
})
export class DeviceMovedComponent implements OnInit {
    @Input() notification: Notification = null;
    @Output() markedRead = new EventEmitter();
    @Output() deleteNotification = new EventEmitter();

    constructor() {}

    ngOnInit() {}
}
